import { Resolver, gql } from '@apollo/client';

import axios from 'axios';
import HttpStatus from 'http-status-codes';

interface Args {
    filename: string;
    statementId: string;
    version: string;
    proStatementViewUrl: string;
}

interface Result {
    response: {
        data: ProIngestionDashboard | null;
    };
    filename: string;
}

export const getTrqkStatementView: Resolver = async (
    obj: Record<string, unknown>,
    args: Args,
): Promise<Result> => {
    const { filename, statementId, version, proStatementViewUrl } = args;

    try {
        const response = await axios({
            method: 'post',
            url: proStatementViewUrl,
            data: {
                statement_id: statementId,
                version: parseFloat(version),
            },
        });

        return {
            response,
            filename,
        };
    } catch (err) {
        if (err?.response?.status === HttpStatus.NOT_FOUND) {
            return {
                response: {
                    data: null,
                },
                filename,
            };
        }

        throw err;
    }
};

export const GET_TRQK_STATEMENT_VIEW = gql`
    mutation GetTrqkStatementView(
        $filename: String
        $statementId: String
        $version: Float
        $proStatementViewUrl: String
    ) {
        getTrqkStatementView(
            filename: $filename
            statementId: $statementId
            version: $version
            proStatementViewUrl: $proStatementViewUrl
        ) @client
    }
`;
